import React from 'react';
import { defineMessages, FormattedMessage, defineMessage } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

const prefix = SharedIntlProviderHOC.getUrlPrefix();
const urlPrefix = prefix ? `/${prefix}` : '';

const definedMessages = defineMessages({
  rules: {
    id: 'shared.production_utils.rules',
    defaultMessage: 'General Rules'
  },
  minAgeAllowed: {
    id: 'shared.production_utils.min_age_allowed',
    defaultMessage: 'Ages {answer}+'
  },
  allAgeAllowed: {
    id: 'shared.production_utils.all_age_allowed',
    defaultMessage: 'All ages are allowed in the space'
  },
  prodInsuranceRequired: {
    id: 'shared.production_utils.insurance',
    defaultMessage: 'Production insurance is required'
  },
  noProdInsuranceRequired: {
    id: 'shared.production_utils.no_insurance',
    defaultMessage: 'Production insurance is not required'
  },
  moveFurniture: {
    id: 'shared.production_utils.move_furniture',
    defaultMessage: 'Furniture and decorations may be moved'
  },
  noMoveFurniture: {
    id: 'shared.production_utils.no_move_furniture',
    defaultMessage: 'No moving furniture and decorations'
  },
  smokeMachine: {
    id: 'shared.production_utils.smoke_machine',
    defaultMessage: 'Smoke machines are allowed'
  },
  noSmokeMachine: {
    id: 'shared.production_utils.no_smoke_machine',
    defaultMessage: 'No smoke machines allowed'
  },
  nudity: {
    id: 'shared.production_utils.nudity',
    defaultMessage: 'Nudity is allowed'
  },
  noNudity: {
    id: 'shared.production_utils.no_nudity',
    defaultMessage: 'No nudity allowed'
  },
  hostRules: {
    id: 'shared.production_utils.host_rules',
    defaultMessage: 'Host rules'
  }
});

export const rulesFAQ = (answer) => (
  {
    rules: {
      label: definedMessages.rules,
      description: answer
    },
    min_age: {
      label: 0 < answer ? definedMessages.minAgeAllowed : definedMessages.allAgeAllowed
    },
    requires_production_insurance: {
      label: answer ? definedMessages.prodInsuranceRequired : definedMessages.noProdInsuranceRequired
    },
    insurance_requirement_description: {
      description: answer
    },
    can_move_furniture: {
      label: answer ? definedMessages.moveFurniture : definedMessages.noMoveFurniture
    },
    furniture_move_description: {
      description: answer
    },
    can_use_smoke_machines: {
      label: answer ? definedMessages.smokeMachine : definedMessages.noSmokeMachine
    },
    nudity_allowed: {
      label: answer ? definedMessages.nudity : definedMessages.noNudity
    },
    has_surveillance: {
      label: answer
    },
    surveillance_description: {
      description: (
        answer
          && <div>
            <div className="margin-xl-bottom">{answer}</div>
            <div>
              <FormattedMessage
                id='shared.production_utils.recording_device'
                defaultMessage='Recording devices in bathrooms or dressing rooms are prohibited by the {link}.'
                values={{
                  link: (<a href={`${urlPrefix}/terms`}>
                    <FormattedMessage
                      id='shared.production_utils.agreement'
                      defaultMessage='Peerspace Services Agreement'
                    />
                  </a>)
                }}
              />
            </div>
          </div>
      )
    }
  }
);

export const hostRulesQuestions = {
  rules: {
    label: definedMessages.hostRules,
    icon: 'rules',
    keys: [
      'requires_production_insurance',
      'insurance_requirement_description',
      'can_move_furniture',
      'furniture_move_description',
      'can_use_smoke_machines',
      'nudity_allowed',
      'has_surveillance',
      'surveillance_description'
    ],
    faq: rulesFAQ
  }
};
